import type { EventsResponse } from '@dashboard/contract';
import { CLASS_LABEL, fmtM, monthLabel } from '../lib/format';

export function EventsTable({ data }: { data: EventsResponse }) {
  const evs = data.events.slice(0, 25);
  return (
    <div className="scroll">
      <table id="t-events">
        <thead>
          <tr>
            <th className="name">Song</th>
            <th>Month</th>
            <th>Type</th>
            <th>Age</th>
            <th>vs baseline</th>
            <th>Gained</th>
            <th>Kept</th>
            <th className="cz">Cause</th>
          </tr>
        </thead>
        <tbody>
          {evs.length === 0 ? (
            <tr>
              <td className="name">No events</td>
              <td colSpan={7} />
            </tr>
          ) : (
            evs.map((e) => (
              <tr key={e.id}>
                <td className="name" title={e.title}>
                  {e.title}
                </td>
                <td>{monthLabel(e.month)}</td>
                <td>
                  <span className={`badge ${e.class}`}>{CLASS_LABEL[e.class]}</span>
                </td>
                <td>{e.ageMonths == null ? '—' : `${e.ageMonths}mo`}</td>
                <td className="pos">+{(e.dev * 100).toFixed(0)}%</td>
                <td>{fmtM(e.gain)}M</td>
                <td
                  className={
                    e.persist == null ? '' : e.persist > 0.5 ? 'pos' : e.persist < 0 ? 'neg' : ''
                  }
                >
                  {e.persist == null
                    ? '—'
                    : `${e.persist > 0 ? '+' : ''}${(e.persist * 100).toFixed(0)}%`}
                </td>
                <td className="cz">
                  {e.attribution ? (
                    <span className="evcause">
                      {e.attribution.cause}
                      {e.attribution.sourceUrl ? (
                        <>
                          {' '}
                          <a
                            href={e.attribution.sourceUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            source
                          </a>
                        </>
                      ) : null}
                    </span>
                  ) : e.candidates.length ? (
                    <span style={{ color: 'var(--muted)' }}>
                      possible: {e.candidates.map((c) => c.title).join('; ')}
                    </span>
                  ) : (
                    <span style={{ color: 'var(--faint)' }}>not yet researched</span>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
